import {  types  } from '../../actions'

function getSeasonsSetup(seasons){     
	const seasonSetup = {}
	seasons.map(function(season) {
		seasonSetup[season.id] = getSingleSeasonSetup(season)
	})

	return seasonSetup
}

function getSingleSeasonSetup(season) {
	const { id, leagueMinGames, tournamentMinGames, tournamentCity, tournamentState, tournamentDate, isSeasonSet } = season
	const setup = {
		seasonId: id,
			leagueMinGames,
			tournamentMinGames,
			tournamentCity,
			tournamentState,
			tournamentDate,
			isSeasonSet
	}
  return setup
}
       
export default function seasonsetup (state={},action) {   
	const {  payload } = action      
				
	switch(action.type) {
		case (types.Season.FETCH_ACTIVE_SEASONS): {           
			const { data } = payload
			
			if (data) {                
				const defaultId = payload.data[0].id
				const setup = getSeasonsSetup(data)
				const newstate = {
					setup,
					settingsseason:defaultId,
					initialstate:setup,
					setupreset:false,
				}

				return Object.assign({},state, {
					values: newstate,
					fields: newstate
					}
				)
			}
			else {
					return state
			}
		}
		case types.Season.SAVING_SEASON_SETUP: {
			const response = {
				savingsetup: true,
			}
			return  { ...state, 
				values: {
					...state.values ,
					...response        
				},
				fields: {
					...state.fields,
					...response 
				}
			}
		}
		case types.Season.SAVE_SEASON_SETUP: {
			const datasaved  = true 
			const savingsetup = false
			const setupreset = false
			const newstate   = {
				initialstate:state.values.setup,
				savingsetup,
				datasaved,
				setupreset    
			}

			return  { 
				...state, 
				values: {
					...state.values,
					...newstate      
				},
				fields: {
					...state.fields,
					...newstate
				}
			}
		}
		case types.Season.TRIGGER_SEASON: {
			const { data } = payload
						
			if (data) {                
				const defaultId = data[data.length - 1].id
				const setup = getSeasonsSetup(data)
				const response = {
					setup,
					settingsseason:defaultId,
					initialstate:setup,
					setupreset:false,
				}

				return  { 
					...state, 
					values:
					{
						...state.values ,
						...response        
					},
					fields: 
					{
						...state.fields,
						...response 
					}
				}
			}
			else {
					return state
			}
			
		}
		case types.RESET_SETUP_SETTINGS:{
             
            const { initialstate } = state.values

            const response = {
              setup:initialstate,
              setupreset:true
            }
          
            return  { ...state, 
                values: {
                         ...state.values,
                         ...response
                       },
                fields: {
                         ...state.fields,
                         ...response
                       }
             }
        }
		default: return state
	}
}


// WEBPACK FOOTER //
// ./src/redux/reducers/forms/seasonsetup.js